<template>
  <HttpContentView endpoint="admin/communities/types" @response="types = $event">
    <template v-slot:content>
      <h2 class="mb-3">{{ translate("community.create.select_type") }}</h2>
      <div class="row g-4">
        <div class="col-6 col-lg-3 col-xl-2 clickable mb-3" v-for="type in types" :key="type.key" @click="typeSelected(type)">
          <div class="card" :class="{ 'border-primary': selectedType?.key === type.key }">
            <div class="card-body text-center">
              <img :src="type.imageUrl" style="height: 2em; width: auto; opacity: 0.9"/>
              <div class="fw-bold mt-3">{{ type.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedType" class="mt-4">
        <h2 class="mb-3">{{ translate("community.create.select_primary_player_identifier") }}</h2>
        <div class="alert alert-info d-flex align-items-center g-3 mb-3">
            <i class="fas fa-exclamation-circle text-info fa-lg"></i>
            {{ translate("community.create.select_primary_player_identifier.explanation") }}
        </div>
        <div class="row g-4">
          <div class="col-6 col-lg-3 col-xl-2 clickable mb-3" v-for="type in selectedType.primaryPlayerIdentifierTypes" :key="type.key" @click="$emit('update:identifier-type', type.key)">
            <div class="card" :class="{ 'border-primary': selectedIdentifierType?.key === type.key }">
              <div class="card-body">
                <div class="text-center">
                  <i :class="type.icon" style="font-size: 2em"></i>
                  <div class="fw-bold mt-3">{{ type.title }}</div>
                  <div v-if="type.subtitle" class="text-muted small mt-1">{{ type.subtitle }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </HttpContentView>
</template>

<script setup>
import {HttpContentView} from "@/niftybit";
import {computed, ref} from "vue";

const props = defineProps({
  type: String,
  identifierType: String,
});

const emit = defineEmits(["update:type", "update:identifier-type"]);

const types = ref([]);


function typeSelected(type) {
  emit('update:type', type.key);
}

const selectedType = computed(() => props.type ? types.value.find(item => item.key === props.type) : undefined);
const selectedIdentifierType = computed(() => selectedType.value && props.identifierType ? selectedType.value.primaryPlayerIdentifierTypes.find(item => item.key === props.identifierType) : undefined);

</script>

<style scoped>

</style>
